import React, { memo, Fragment } from 'react';
import { Formatter } from '@core/utils/formatter';
import { TableColumn } from '@modules/common/TableColumn';
import { CardTitle } from 'reactstrap';
import { useCompany } from '@core/utils/hooks/misc';

export interface LaborLineItemProps {
  laborCost: number;
  editable?: boolean;
  title: string;
  coPreview?: boolean;
}

export const LaborLineItem = memo((props: LaborLineItemProps) => {
  const { laborCost, title, coPreview = false } = props;
  const company = useCompany();
  return (
    <Fragment>
      <CardTitle className="d-flex align-items-center justify-content-between">
        <div className="row py-2 ml-1">
          <span className="title mr-3 mt-2 font-size-24">Labor</span>
        </div>
      </CardTitle>

      <hr />
      <div className="d-flex align-items-center" style={{ padding: '10px 0px' }}>
        <TableColumn width={50} maxWidth={50}></TableColumn>
        <TableColumn>{title}</TableColumn>
        {!!coPreview && <TableColumn width={300}></TableColumn>}
        <TableColumn maxWidth={100}>{1}</TableColumn>
        <TableColumn maxWidth={100}>{Formatter.formatCurrency(laborCost, company.currencyCode)}</TableColumn>
        {coPreview ? (
          <TableColumn style={{ marginLeft: 20 }} maxWidth={200} className="d-flex justify-content-end">
            {Formatter.formatCurrency(laborCost, company.currencyCode)}
          </TableColumn>
        ) : (
          <TableColumn style={{ marginLeft: 20 }} maxWidth={200}>
            {Formatter.formatCurrency(laborCost, company.currencyCode)}
          </TableColumn>
        )}
        <TableColumn maxWidth={5}></TableColumn>
      </div>
    </Fragment>
  );
});
